import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const collectionCardDefaultVariants = {}
const collectionCardCompoundVariants = []

const collectionCardSlotNames = [
  [
    "root",
    "collection-card__root"
  ],
  [
    "header",
    "collection-card__header"
  ],
  [
    "clientName",
    "collection-card__clientName"
  ],
  [
    "content",
    "collection-card__content"
  ],
  [
    "footer",
    "collection-card__footer"
  ],
  [
    "title",
    "collection-card__title"
  ],
  [
    "meta",
    "collection-card__meta"
  ],
  [
    "listItem",
    "collection-card__listItem"
  ]
]
const collectionCardSlotFns = /* @__PURE__ */ collectionCardSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, collectionCardDefaultVariants, getSlotCompoundVariant(collectionCardCompoundVariants, slotName))])

const collectionCardFn = memo((props = {}) => {
  return Object.fromEntries(collectionCardSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const collectionCardVariantKeys = []
const getVariantProps = (variants) => ({ ...collectionCardDefaultVariants, ...compact(variants) })

export const collectionCard = /* @__PURE__ */ Object.assign(collectionCardFn, {
  __recipe__: false,
  __name__: 'collectionCard',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: collectionCardVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, collectionCardVariantKeys)
  },
  getVariantProps
})